interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
      <div className={`flex items-center gap-3 ${isCenter ? "justify-center" : ""}`}>
        <span className="h-px w-8 bg-primary-500/70" />
        <span className="font-label text-xs uppercase tracking-[0.3em] text-primary-700">{eyebrow}</span>
      </div>
      <h2 className="mt-4 font-heading text-2xl leading-tight text-foreground-950 md:text-4xl">{title}</h2>
      {desc ? <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p> : null}
    </div>
  );
}